
import { getSearchInitData, delOneModel } from "@/api/api-basic";
import { getRatePageList } from "@/api/api-rate";

import piSelectOper from "@/components/select-oper/select-oper.vue";
import piRateAdd from "./components/pi-rate-add.vue";
import piRateDetail from "./components/pi-rate-detail.vue";
import piDelayDetail from "./components/pi-delay-detail.vue";
import piBindNumDetail from "./components/pi-bindnum-detail.vue";
import i18n from "@/config/i18n";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component({
  components: {
    "pi-select-oper": piSelectOper,
    "pi-rate-add": piRateAdd,
    "pi-rate-detail": piRateDetail,
    "pi-delay-detail": piDelayDetail,
    "pi-bindnum-detail": piBindNumDetail
  }
})
export default class AlarmSetting extends Vue {
  private piRateNumberDetail: objAny = {};
  private piRateAdd: objAny = {};
  private piRateDetail: objAny = {};
  private piDelayDetail: objAny = {};
  private piBindNumDetail: objAny = {};

  private loading = false;
  private modelList = [];
  private oprList: object[] = [];
  // private deviceTypeList = [];
  private devTypeList: object[] = [];
  private alarmLevelList = [];
  private eventTypeList = [];
  private stationList = [];
  private total = 0;
  private time: object[] = [];

  private formInline: objAny = {
    startTime: "",
    endTime: "",
    key: "",
    feeType: "1",
    oprPkId: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalOrder: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private slotFlagTextAC = [
    i18n.t("ratamanage.jian"),
    i18n.t("ratamanage.feng"),
    i18n.t("ratamanage.ping"),
    i18n.t("ratamanage.gu")
  ];
  private slotFlagTextDC = [
    i18n.t("ratamanage.jian"),
    i18n.t("ratamanage.feng"),
    i18n.t("ratamanage.ping"),
    i18n.t("ratamanage.gu")
  ];

  private tableColumns: object[] = [
    {
      title: i18n.t("oprName"),
      key: "oprName",
      resizable: true,
      minWidth: 130,
      slot: "oprName"
    },
    {
      title: i18n.t("ratamanage.templateName"),
      key: "feeName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("ratamanage.acRate"),
      key: "slotElecPrice",
      resizable: true,
      minWidth: 130,
      slot: "acRate"
    },
    {
      title: i18n.t("ratamanage.dcRate"),
      key: "slotElecPrice",
      resizable: true,
      minWidth: 130,
      slot: "dcRate"
    },
    {
      title: i18n.t("ratamanage.delayRate"),
      key: "delayRate",
      resizable: true,
      minWidth: 130,
      slot: "delayRate"
    },
    {
      title: i18n.t("ratamanage.bindStaNum"),
      key: "bindStaNum",
      resizable: true,
      minWidth: 90,
      slot: "bindStaNum"
    },
    {
      title: i18n.t("ratamanage.modifyTime"),
      key: "modifyTime",
      resizable: true,
      minWidth: 120
    },
    {
      title: i18n.t("operation"),
      resizable: true,
      minWidth: 140,
      slot: "action"
    }
  ];
  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
  }
  public operSuccess(list: object[]): void {
    this.oprList = list;
  }
  public queryRate(): void {
    this.getTableList();
  }
  public addNewAbout(): void {
    this.piRateAdd.open(null, "oms");
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  public acRateDetail(item: objAny): void {
    this.piRateDetail.open(item, "ac");
  }
  public dcRateDetail(item: objAny): void {
    this.piRateDetail.open(item, "dc");
  }
  public delayRateDetail(item: objAny): void {
    this.piDelayDetail.open(item, "delay");
  }
  public bindnumRateDetail(item: objAny): void {
    this.piBindNumDetail.open(item, "bindnum", "oms");
  }
  // 修改
  public updRate(item: objAny): void {
    this.piRateAdd.open(item, "update");
  }
  // 删除
  async delItemRate(deviceModelPkId: string): Promise<void> {
    const deviceModelPkIds = [deviceModelPkId];
    const ret = await delOneModel({ deviceModelPkIds });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  async getTableList(): Promise<void> {
    // if (this.formInline.startTime == "" || this.formInline.endTime == "") {
    //   this.$Message.error("更新时间不能为空 !");
    //   return;
    // }
    this.loading = true;
    const ret = await getRatePageList(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  async searchInitData(): Promise<void> {
    const ret = await getSearchInitData();
    if (ret.status === this.$config.apiStatus) {
      this.oprList = ret.data[0].oprList;
      // this.deviceTypeList = ret.data[0].deviceTypeList;
      this.alarmLevelList = ret.data[0].alarmLevelList;
      this.eventTypeList = ret.data[0].eventTypeList;
      this.stationList = ret.data[0].stationList;
    }
  }
  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.startTime =
        this.$common.userDate(val[0]).split(" ")[0] + " 00:00:00";
      this.formInline.endTime =
        this.$common.userDate(val[1]).split(" ")[0] + " 23:59:59";
    } else {
      this.formInline.startTime = "";
      this.formInline.endTime = "";
    }
  }
  public created(): void {
    const startTime = this.$common.thisTimes("yyyy-MM");
    const endTime = this.$common.thisTimes("yyyy-MM-dd");
    this.formInline.startTime = startTime + "-01 00:00:00";
    this.formInline.endTime = endTime + " 23:59:59";
    this.time = [this.formInline.startTime, this.formInline.endTime];

    this.getTableList();
    // this.searchInitData();
  }
  mounted() {
    this.$nextTick((): void => {
      this.piRateAdd = this.$refs["piRateAdd"];
      this.piRateDetail = this.$refs["piRateDetail"];
      this.piDelayDetail = this.$refs["piDelayDetail"];
      this.piBindNumDetail = this.$refs["piBindNumDetail"];
    });
    // this.privilege = this.$route.meta.privilegeVoObj;
  }
}
